import { Directive, effect, inject, Input, signal, TemplateRef, ViewContainerRef, WritableSignal } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

@Directive({
  selector: '[ffEnabled]',
})
export class FeatureFlagDirective {
  private flags = inject(FeatureFlagService);
  private tpl = inject(TemplateRef<any>);
  private vcr = inject(ViewContainerRef);

  private readonly key: WritableSignal<string> = signal('');
  private readonly elseTpl: WritableSignal<TemplateRef<any> | null> = signal(null);

  @Input() set ffEnabled(key: string) {
    this.key.set(key);
  }

  @Input() set ffEnabledElse(tpl: TemplateRef<any>) {
    this.elseTpl.set(tpl);
  }

  constructor() {
    // Re-render whenever the key, the else-template, or the underlying flag value changes.
    // FeatureFlagService.enabled() returns a signal that starts false and flips to the real
    // value once the flags settle (loaded asynchronously during auth), so reading it inside
    // an effect keeps the view in sync instead of rendering once against the initial value.
    effect(() => {
      const enabled = this.flags.enabled(this.key())();
      const elseTpl = this.elseTpl();
      this.vcr.clear();
      if (enabled) {
        this.vcr.createEmbeddedView(this.tpl);
      } else if (elseTpl) {
        this.vcr.createEmbeddedView(elseTpl);
      }
    });
  }
}
